var render = function render(){var _vm=this,_c=_vm._self._c;return (new Array('User', 'Corrector', 'Animator', 'Admin', 'SuperAdmin').includes(_vm.profile.role))?_c('div',[_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v("Fichiers :")]),_c('v-card-text',[_c('FileList',{attrs:{"profile":_vm.profile,"user":_vm.user,"notifications":_vm.notifications,"currentRoom":_vm.currentRoom}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }